import { Subject } from 'rxjs';
import { WcMissionPayload } from '../types';

const wcMissionSubject$ = new Subject<WcMissionPayload>();

export const wcPromotionMissionService = {
	notifyMission: (payload: WcMissionPayload) => wcMissionSubject$.next(payload),
	mission$: wcMissionSubject$.asObservable(),
};